import { DealProcessingStatus, ProcessingCountersType } from '@common/model/processing';
import { adminProcessingApi } from '../api';

const processingNegotiationBadgeCountQuery = {
  vacancyId: { isEmpty: true },
} as const;

export const useProcessingNegotiationBadgeCountQuery = () => {
  const { data, isSuccess } = adminProcessingApi.endpoints.getProcessingCounters.useQuery(processingNegotiationBadgeCountQuery);

  const negotiation = data?.counters?.[ProcessingCountersType.Negotiation];
  const count = negotiation?.status === DealProcessingStatus.Waiting ? negotiation.count ?? 0 : 0;

  return {
    count,
    isReady: isSuccess,
  };
};

export const useProcessingNegotiationBadgeCount = (): number => {
  return useProcessingNegotiationBadgeCountQuery().count;
};
